import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Backdrop,
  Menu,
  MenuItem,
  Modal,
  InputLabel,
  Select,
  FormControl,
  styled,
  TextField,
  FormHelperText,
  InputAdornment,
  IconButton,
  Checkbox,
  AppBar,
  Tabs,
  Tab,
  ListItemIcon,
} from "@mui/material";
import { ArrowDropDown, Download, Logout, Sync } from "@mui/icons-material";

import api, { baseURL } from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setDashboardPageNumber,
  setDashboardSearchValue,
  setFilesPartsEmpty,
  setFileType,
  setReportPageNumber,
  setReportSearchValue,
  setSelectBoxInReport,
  setSelectedFileFormatId,
  setSelectedFileReports,
} from "../slice/searchPaginationSlice";
import ClearIcon from "@mui/icons-material/Clear";

const Dashboard = () => {
  const navigate = useNavigate();
  const { employeeId } = useParams();
  const location = useLocation();
  const { agencyName } = location?.state || "";
  const [loading, setLoading] = useState(true);
  const [fileUploadLoading, setFileUploadLoading] = useState(false);
  const [dashboardList, setDashboardList] = useState([]);
  const [count, setCount] = useState(0);
  const [demoAnchor, setDemoAnchor] = useState(null);
  const [uploadAnchor, setUploadAnchor] = useState(null);
  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false);
  const [isOpenFileUploadMoadl, setIsOpenFileUploadModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [dataSetType, setSelectedDataSetType] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [fileTypes, setFileTypes] = useState([]);
  const [openSelectAgenciesModal, setOpenSelectAgenciesModal] = useState(false);
  const [agenciesList, setAgenciesList] = useState([]);
  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const {
    dashboardPageNumber,
    dashboardSearchValue,
    fileType,
    selectedFileReports,
    selectedFileFormatId,
  } = useSelector((store) => store.searchPagination);
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState(dashboardSearchValue ? dashboardSearchValue : "");
  useEffect(() => {
    dashboardData();
  }, [dashboardPageNumber]);
  let handler;

  useEffect(() => {
    // getAgencies();
    return () => {
      dispatch(setDashboardPageNumber(0));
      clearTimeout(handler);
    };
  }, []);

  const getAgencies = async () => {
    try {
      const response = await api.get("/agency/agencies-with-access");
      console.log(response, "response");
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleSelectAgencies = async (row) => {
    try {
      setSelectedRow(row);
      // Initialize selectedAgencies with existing allowed_agencies
      if (row?.allowed_agencies && Array.isArray(row.allowed_agencies)) {
        setSelectedAgencies(row.allowed_agencies.map(id => String(id)));
      } else {
        setSelectedAgencies([]);
      }
      const response = await api.get("/agency/agencies-with-access",{
        params:{
          agency_id: row?.agency_id
        }
      });
      if (response?.data?.data) {
        setAgenciesList(Array.isArray(response.data.data) ? response.data.data : []);
      } else if (response?.data) {
        setAgenciesList(Array.isArray(response.data) ? response.data : []);
      } else {
        setAgenciesList([]);
      }
    } catch (error) {
      setAgenciesList([]);
      setSelectedAgencies([]);
    }
    setOpenSelectAgenciesModal(true);
  };

  const handleSaveSelectedAgencies =  async() => {
    try{
      const selectedAgencyObjects = agenciesList.filter((agency) =>
        selectedAgencies.includes(String(agency.agency_id || agency.id))
      );

       await api.patch("upload-request/allowed-agencies", {
        id: selectedRow?.id,
        allowed_agencies: selectedAgencyObjects.map((agency) =>  agency.id.toString()),
      })

      toast.success("Selected Agencies saved successfully!");
      setOpenSelectAgenciesModal(false);
      setSelectedAgencies([]);
      // Refetch table data after saving agencies
      dashboardData();
    }catch(error){
      toast.error(error?.response?.data?.error ?? "Error saving selected agencies. Please try again.");
    }
    
  };

  const getFileType = async () => {
    try {
      const response = await api.get("/agency-format/all-formats");

      if (response?.data?.success) {
        setFileTypes(response?.data?.data);
      }
    } catch (e) {}
  };
  const [agencies, setAgencies] = useState(["All"]);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    console.log(newValue, "newValue");
    setSelectedTab(newValue);
  };
  console.log(agencies, "agencies");
  const getAllAgency = async () => {
    try {
      const response = await api.get(`agency-format/all-formats/${employeeId}`);
      if (response?.data?.success) {
        if (Array.isArray(response?.data?.data?.agencyFormats)) {
          let reqAgencies = response?.data?.data?.agencyFormats.map((item) => {
            let data = {
              id: item?.id,
              name: item?.name,
            };
            return data;
          });
          setAgencies([{ name: "All", id: 0 }, ...reqAgencies]);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (employeeId) {
      getAllAgency();
    }
  }, [employeeId]);
  const handleSearch = (search) => {
    setSearchQuery(search);
    dispatch(setDashboardSearchValue(search));

    /*handler = setTimeout(() => {
      dashboardData(0, search);

      // setDebouncedQuery(search);
      // dispatch(setReportSearchValue(search));

      // dispatch(setReportPageNumber(0));
    }, 500);**/
  };
  // const [page, setPage] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [debouncedQuery, setDebouncedQuery] = useState("");

  const userInfo = getLocalStorage("user") ? JSON.parse(getLocalStorage("user")) : null;

  const dashboardData = async (number, search = "", type = fileType) => {
    try {
      setDownloadCSVLoading(true);
      let apiPath = `agency/list-of-files/${employeeId}/?search=${
        search || searchQuery
      }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;
      if (type) {
        apiPath = `agency/list-of-files/${employeeId}/${type}/?search=${
          search || searchQuery
        }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;
      }
      const response = await api.get(apiPath);
      // console.log(response, "response");
      setDashboardList(response?.data?.data?.rows);
      setCount(response?.data?.data?.count);
      // setDashboardList(response?.data?.count);
    } catch (error) {
      toast.error(error?.response?.data?.error ?? "Error fetching data. Please try again.");
    } finally {
      setLoading(false);
      setDownloadCSVLoading(false);
    }
  };

  const handleDemoMenuClick = (event) => {
    setDemoAnchor(event?.currentTarget);
  };

  const handleDemoMenuClose = (option) => {
    setDemoAnchor(null);
    if (option === "csv") downloadDemoFileCsv();
    if (option === "dbf") downloadDemoFileDbf();
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setDashboardPageNumber(newPage));
  };

  const downloadDemoFileCsv = () => {
    let demoFileUrl;
    /*let demoFileUrl = "";
    if (userInfo?.role.toLowerCase() === "Agency1".toLowerCase()) {
     
    } else if (userInfo?.role.toLowerCase() === "Agency2".toLowerCase()) {
      demoFileUrl = "./assets/student_report_2.csv";
    }**/
    demoFileUrl = "./assets/student_report_1.csv";
    const anchor = document.createElement("a");
    anchor.href = demoFileUrl;
    anchor.download = "student_report.csv";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const downloadDemoFileDbf = () => {
    let demoFileUrl = "";

    /* if (userInfo?.role.toLowerCase() === "Agency1".toLowerCase()) {
      demoFileUrl = "./assets/student_report_1.dbf";
    } else if (userInfo?.role.toLowerCase() === "Agency2".toLowerCase()) {
      demoFileUrl = "./assets/student_report_2.dbf";
    }**/

    const anchor = document.createElement("a");
    anchor.href = demoFileUrl;
    anchor.download = "student_report.dbf";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleUploadMenuClick = (event) => {
    setIsOpenFileUploadModal(true);
    // setUploadAnchor(event?.currentTarget);
  };

  const handleUploadMenuClose = (option) => {
    setUploadAnchor(null);
    if (option) document.getElementById(`fileInput-${option}`).click();
  };
  const clearFileState = () => {
    setSelectedClass(null);
    setSelectedDataSetType(null);
    setSelectedFileType(null);
    setUploadedFile(null);
  };
  const apiCall = async (event, fileType) => {
    const file = uploadedFile;
    if (!file) {
      toast.error("No file selected!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("format_id", dataSetType);
    /* formData.append(
      "uploadedBy",
      getLocalStorage("user")
        ? JSON.parse(getLocalStorage("user"))?.id
        : undefined
    );
    formData.append("classType", selectedClass);
    formData.append("datasetType", dataSetType);
    formData.append("fileType", selectedFileType);**/

    setFileUploadLoading(true);
    try {
      const response = await api.post("upload-request/upload-file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response?.data?.success) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }

      setIsOpenFileUploadModal(false);
      clearFileState();
      dashboardData();
    } catch (error) {
      toast.error(error?.response?.data?.error ?? "File upload failed. Please try again.");
    } finally {
      setFileUploadLoading(false);
    }
  };

  const formatCustomDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} ${time}`;
  };

  const handleDownloadCSV = async (csvId, fileName, newName) => {
    if (newName) {
      let demoFileUrl = `${baseURL}${newName}`;
      const anchor = document.createElement("a");
      anchor.href = demoFileUrl;
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      // setOpenDownLoadModal(false);
    } else {
      setDownloadCSVLoading(true);
      try {
        const response = await api.get(`agency/download/${csvId}`);
        if (response?.data?.success) {
          toast.success(response?.data?.success);
        }

        if (response) {
          downloadCSV(response?.data, fileName);
        } else {
          toast.error("CSV link not found in the response.");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.error ?? "Error fetching the CSV link, please try again."
        );
        return null;
      } finally {
        setDownloadCSVLoading(false);
      }
    }
  };

  // const downloadCSV = (csvLink) => {
  //   if (csvLink) {
  //     const fileUrl = csvLink;
  //     const anchor = document.createElement("a");
  //     anchor.href = fileUrl;
  //     document.body.appendChild(anchor);
  //     anchor.click();
  //     document.body.removeChild(anchor);
  //   } else {
  //     console.error("Invalid CSV link provided.");
  //   }
  // };
  const downloadCSV = (csvData, fileName = "data.csv") => {
    if (!csvData) {
      console.error("Invalid CSV data provided.");
      return;
    }

    // Convert data to a Blob (CSV format)
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a hidden anchor tag and trigger download
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    // Clean up the URL
    URL.revokeObjectURL(url);
  };

  const handleRowClick = (id) => {
    dispatch(setReportPageNumber(0));
    dispatch(setReportSearchValue(""));
    dispatch(setSelectBoxInReport(""));

    navigate(`/report/${id}`);
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };
  const submitData = () => {
    //

    // if (!selectedClass) {
    //   setErrors({ ...errors, selectedClass: "Please Select Class" });
    //   // return toast.error("Please Select Class Type");
    // }
    // if (!dataSetType) {
    //   setErrors({ ...errors, dataSetType: "Please Select DataSet Type" });

    //   // return toast.error("Please Select DataSet Type");
    // }
    // if (!selectedFileType) {
    //   setErrors({ ...errors, selectedFileType: "Please Select File Type" });

    //   // return toast.error("Please Select File Type");
    // }
    // if (!uploadedFile) {
    //   setErrors({ ...errors, uploadedFile: "Please Upload File " });

    //   // return toast.error("Please Upload File");
    // }

    const newErrors = {}; // Collect all errors first

    if (!selectedClass) {
      newErrors.selectedClass = "Please Select Class";
    }

    if (!dataSetType) {
      newErrors.dataSetType = "Please Select DataSet Type";
    }

    if (!selectedFileType) {
      newErrors.selectedFileType = "Please Select File Type";
    }

    if (!uploadedFile) {
      newErrors.uploadedFile = "Please Upload File";
    }

    // Update errors state once (this ensures all errors are displayed)
    if (Object.keys(newErrors).length > 0) {
      setErrors({ ...errors, ...newErrors });
      return; // Prevent further execution
    }
    if (selectedClass && dataSetType && selectedFileType && uploadedFile) {
      apiCall();
    }
  };
  const menuItems = {
    Matric: [
      // { key: "Matric_Practical_Raw_DATA", label: "Matric Practical Raw DATA" },
      { key: "MATRIC_PRACTICAL_DATA", label: "Matric Practical DATA" },
      // { key: "MATRIC_OMR_RAW_DATA", label: "MATRIC OMR RAW DATA" },
      { key: "MATRIC_OMR_DATA", label: "MATRIC OMR DATA" },
      // { key: "MATRIC_FOIL_RAW_DATA", label: "MATRIC FOIL RAW DATA" },
      { key: "MATRIC_FOIL_DATA", label: "MATRIC FOIL DATA" },
      // { key: "MATRIC_AWARD_RAW_DATA", label: "MATRIC AWARD RAW DATA" },
      { key: "MATRIC_AWARD_DATA", label: "MATRIC AWARD DATA" },
    ],
    Inter: [
      // { key: "INTER_PRACTICAL_RAW_DATA", label: "INTER PRACTICAL RAW DATA" },
      { key: "INTER_PRACTICAL_DATA", label: "INTER PRACTICAL DATA" },
    ],
  };
  const chooseFile = () => {
    if (!selectedFileType) {
      toast.error("Please Select File Type");
      return;
    }
    if (selectedFileType == "DBF") {
      handleUploadMenuClose("dbf");
      return;
    }
    if (selectedFileType == "CSV") {
      handleUploadMenuClose("csv");
      return;
    }
  };
  const onUploadFile = (e) => {
    const file = e.target.files[0];
    setUploadedFile(file);
    e.target.value = null;
  };

  const handleCloseFileMOdal = () => {
    setUploadedFile(null);
    setSelectedFileType(null);
    setSelectedDataSetType(null);
    setSelectedClass(null);
    setErrors({});
    setIsOpenFileUploadModal(false);
  };
  const getFileTypes = () => {
    const VALUES = {
      Matric: 2,
      Inter: 1,
    };
    if (selectedClass) {
      const filterData = fileTypes?.agencyFormats?.filter(
        (item) => item?.class_type == VALUES[selectedClass]
      );

      return filterData;
    } else {
      return [];
    }
  };
  const searchRecord = () => {
    dispatch(setDashboardPageNumber(0));

    dashboardData(0, searchQuery);
  };

  const [selectedRows, setSelectedRows] = useState([...selectedFileReports]);
  const [selectedFormat, setSelectedFormat] = useState(selectedFileFormatId);

  useEffect(() => {
    dispatch(setSelectedFileFormatId(selectedFormat));
  }, [selectedFormat]);
  useEffect(() => {
    dispatch(setSelectedFileReports(selectedRows));
  }, [selectedRows?.length]);
  console.log(selectedRows, "selectedRows");
  // Function to handle selection
  const handleSelectRow = (id, formatId) => {
    if (selectedFormat !== formatId) {
      setSelectedFormat(formatId);
    }
    if (selectedRows.length === 1 && selectedFormat == formatId && selectedRows.includes(id)) {
      setSelectedFormat(null);
    }
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleMultiDownLoad = async () => {
    try {
      setDownloadCSVLoading(true);
      let data = {
        format_id: selectBox == 0 ? selectedFormat : selectBox,
        upload_id: [...selectedRows],
      };
      // const response = await api.post("agency/consolidated-download", data, {
      //   responseType: "blob", // Important: tells axios to handle binary data
      // });

      const response = await api.post("agency/consolidated-download", data);

      if (response?.data?.success) {
        toast.success(
          response?.data?.message ??
            "Your request is being processed. The file will be sent to your email."
        );

        // let url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "consolidated_data.csv"); // Set file name
        // document.body.appendChild(link);
        // link.click();
        // link.remove();
        // toast.success("CSV downloaded successfully!");
        setSelectedRows([]);
        setSelectedFormat(null);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error ?? "Error Downloading... Please try again.");
    } finally {
      setDownloadCSVLoading(false);
    }
  };

  const [selectBox, setSelectBox] = useState(fileType);
  // useEffect(() => {
  //   dashboardData(0, searchQuery, fileType);
  // }, [fileType]);
  const handleChangeSelectBox = (data) => {
    setSelectBox(data?.target?.value);
    dispatch(setFileType(data?.target?.value));
    dashboardData(0, searchQuery, data?.target?.value);

    console.log(data?.target?.value, "data?.target?.value");
    if (selectBox !== data?.target?.value?.id) {
      setSelectedRows([]);
      setSelectedFormat(null);
    }
    // dispatch(setSelectBoxInReport(data?.target?.value));
  };

  //console.log(selectBox, "selectBox");

  const handleSync = async (item) => {
    setDownloadCSVLoading(false);

    try {
      const response = await api.put("update-request/sync-to-blockchain-queue", {
        upload_id: Number(item?.id),
        format_id: Number(item?.format_id),
        ag_id: Number(employeeId),
      });

      if (response?.data?.success) {
        dashboardData(null, searchQuery);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.error ?? "Error logging in, please try again.");
    } finally {
      setDownloadCSVLoading(false);
    }
  };

  function isNotAllowedExtension(filePath) {
    // Extract the file extension
    const extension = filePath?.split(".")?.pop()?.toLowerCase();

    // Check if it's "mdb" or "bak"
    return extension === "mdb" || extension === "bak";
  }
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      {/* Image Section */}
      <Box display="flex" justifyContent="center" alignItems="center" mb={1} mt={2}>
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {fileUploadLoading ? (
          <Backdrop open={fileUploadLoading} style={{ zIndex: 9999, color: "#fff" }}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : null}

        <Box
          // display="flex"
          // flexWrap="wrap"
          gap="10px"
          // justifyContent="space-between"
          alignItems="center"
          // flexDirection="row"
          mb={3}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            sx={{ marginBottom: "10px", width: "91%" }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              }}
            >
              {userInfo?.employeeName} {""}
              {agencyName} Agency Report
            </Typography>

            <Box>
              <FormControl
                size="small"
                style={{
                  width: "150px",
                  // marginLeft: "25px",
                }}
                fullWidth
              >
                <InputLabel id="demo-simple-select-label">File Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectBox}
                  label="File type"
                  onChange={handleChangeSelectBox}
                  style={{
                    width: "250px",
                  }}
                >
                  {agencies?.map((item) => {
                    return (
                      item !== "position" && (
                        <MenuItem key={item} value={item?.id}>
                          {item?.name}
                        </MenuItem>
                      )
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
            {/* Demo File Dropdown */}
            <TextField
              id="standard-basic"
              label="Search..."
              variant="outlined"
              // onChange={(e) => setSearchQuery(e.target.value)}
              onChange={(e) => handleSearch(e.target.value)}
              value={searchQuery}
              size="small"
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        handleSearch("");
                      }}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={searchRecord}
              style={{
                textTransform: "none",
                backgroundColor: "#8C0001",
              }}
            >
              Search
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/dashboard");

                dispatch(setFilesPartsEmpty());
                dispatch(setDashboardPageNumber(0));
              }}
              style={{ textTransform: "none" }}
            >
              Back to Dashboard
            </Button>

            {selectedRows?.length > 1 && (
              // <Button
              //   variant="text"
              //   color="primary"
              //   style={{
              //     textTransform: "none",
              //     color: "#8C0001",
              //     borderColor: "#8C0001",
              //   }}
              //   startIcon={<Download />}
              //   onClick={handleMultiDownLoad}
              // >
              //   Download Files
              // </Button>

              <Button
                onClick={handleMultiDownLoad}
                variant="outlined"
                // disabled={true}
                startIcon={<Download />}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Download Consolidated Files
              </Button>
            )}

            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none", marginLeft: "auto" }}
            >
              Logout
            </Button>
          </Box>
        </Box>

        {/* <AppBar
          position="static"
          sx={{ backgroundColor: "white", boxShadow: "none" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {agencies.map((agency, index) => (
              <Tab
                key={index}
                label={agency}
                sx={{
                  fontSize: "10px",
                }}
              />
            ))}
          </Tabs>
        </AppBar> */}

        <TableContainer
          // sx={{ maxHeight: "58vh", overflow: "auto" }}
          component={Paper}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow style={{ textWrap: "nowrap", textAlign: "center" }}>
                <TableCell align="center">
                  <strong>CSV Name</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Tag</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Total Records</strong>
                </TableCell>
                {/* <TableCell align="center">
                  <strong>Total Edited Records</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Total Approval Records</strong>
                </TableCell> */}
                <TableCell align="center">
                  <strong>Updated At</strong>
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    background: "white", // Ensures it stays visible
                    zIndex: 2, // Ensures it stays above other columns
                  }}
                >
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardList?.length > 0 ? (
                dashboardList?.map((row) => (
                  <TableRow key={row?.id} style={{ textWrap: "nowrap", textAlign: "center" }}>
                    <TableCell style={{ textAlign: "left" }}>
                      <div>
                        <Checkbox
                          checked={selectedRows.includes(row?.id)}
                          onChange={() => handleSelectRow(row?.id, row?.format_id)}
                          color="primary"
                          disabled={selectedFormat ? selectedFormat !== row?.format_id : false}
                        />
                        <span>
                          {row?.csv_name
                            ? row?.csv_name
                                ?.split("/")
                                ?.pop()
                                ?.replace(/\.[^.]+$/, "")?.length > 30
                              ? row?.csv_name
                                  ?.split("/")
                                  ?.pop()
                                  ?.replace(/\.[^.]+$/, "")
                                  ?.slice(0, 30) + "..."
                              : row?.csv_name
                                  ?.split("/")
                                  ?.pop()
                                  ?.replace(/\.[^.]+$/, "")
                            : "-"}
                        </span>
                      </div>
                    </TableCell>
                    {/* <TableCell style={{ textAlign: "left" }}>
                      <Checkbox
                        checked={selectedRows.includes(row?.id)}
                        onChange={() => handleSelectRow(row?.id)}
                        color="primary"
                      />
                      {row?.csv_name
                        ? // ? row?.csv_name?.split("/")?.pop()?.split(".")?.[0]
                          row?.csv_name
                            ?.split("/")
                            ?.pop()
                            ?.replace(/\.[^.]+$/, "")
                        : "-"}
                    </TableCell> */}
                    <TableCell align="center">
                      {row?.format_details?.name ? row?.format_details?.name : "_"}
                    </TableCell>
                    <TableCell align="center">
                      {isNotAllowedExtension(row?.csv_name)
                        ? "NA"
                        : row?.format_details?.name?.toLowerCase() ===
                            "MasterData"?.toLowerCase() ||
                          row?.format_details?.name?.toLowerCase() === "WantingData"?.toLowerCase()
                        ? "NA"
                        : row?.total_number_records
                        ? row?.total_number_records
                        : 0}
                    </TableCell>
                    {/* <TableCell align="center">
                      {row?.total_edited_records
                        ? row?.total_edited_records
                        : 0}
                    </TableCell>
                    <TableCell align="center">
                      {row?.total_approved_records
                        ? row?.total_approved_records
                        : 0}
                    </TableCell> */}
                    <TableCell align="center">
                      {row?.createdAt ? formatCustomDate(row?.createdAt) : "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        right: 0,
                        marginTop: "6px",

                        background: "white", // Ensures it stays visible
                        zIndex: 1, // Ensures it stays above other columns
                      }}
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <Button
                        variant="text"
                        color="primary"
                        style={{
                          textTransform: "none",
                          color: "#8C0001",
                          borderColor: "#8C0001",
                        }}
                        startIcon={<Download />}
                        onClick={() =>
                          handleDownloadCSV(
                            row?.id,
                            // row?.csv_name?.split("/")?.pop()?.split(".")?.[0]
                            row?.csv_name
                              ?.split("/")
                              ?.pop()
                              ?.replace(/\.[^.]+$/, ""),
                            row?.csv_name
                          )
                        }
                      >
                        Download
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<Sync />}
                        style={{
                          textTransform: "none",
                          backgroundColor: "#8C0001",
                          cursor:
                            isNotAllowedExtension(row?.csv_name) || !row?.total_number_records
                              ? "not-allowed"
                              : row?.format_details?.name?.toLowerCase() ===
                                  "MasterData"?.toLowerCase() ||
                                row?.format_details?.name?.toLowerCase() ===
                                  "WantingData"?.toLowerCase()
                              ? "not-allowed"
                              : row?.status == 0
                              ? "pointer"
                              : "not-allowed",
                          width: "100px",
                          // visibility:
                          //   row?.format_details?.name?.toLowerCase() ===
                          //     "MasterData"?.toLowerCase() ||
                          //   row?.format_details?.name?.toLowerCase() ===
                          //     "WantingData"?.toLowerCase()
                          //     ? "hidden"
                          //     : "visible",
                          opacity:
                            isNotAllowedExtension(row?.csv_name) || !row?.total_number_records
                              ? 0.2
                              : row?.format_details?.name?.toLowerCase() ===
                                  "MasterData"?.toLowerCase() ||
                                row?.format_details?.name?.toLowerCase() ===
                                  "WantingData"?.toLowerCase()
                              ? 0.2
                              : 1,
                        }}
                        size="small"
                        onClick={() => {
                          if (isNotAllowedExtension(row?.csv_name) || !row?.total_number_records) {
                            return;
                          } else if (
                            row?.status == 0 &&
                            row?.format_details?.name?.toLowerCase() !==
                              "MasterData"?.toLowerCase() &&
                            row?.format_details?.name?.toLowerCase() !==
                              "WantingData"?.toLowerCase()
                          ) {
                            handleSync(row);
                          }
                        }}
                      >
                        {row?.status == 2 ? "Syncing.." : row?.status == 1 ? "Synced" : "Sync"}
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectAgencies(row);
                        }}
                      >
                        Select
                      </Button>
                      {row?.format_details?.name?.toLowerCase() !== "MasterData"?.toLowerCase() &&
                      row?.format_details?.name?.toLowerCase() !== "WantingData"?.toLowerCase() &&
                      !isNotAllowedExtension(row?.csv_name) &&
                      row?.total_number_records
                        ? true
                        : false && (
                            <Button
                              variant="contained"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#8C0001",
                                cursor: isNotAllowedExtension(row?.csv_name)
                                  ? "not-allowed"
                                  : row?.format_details?.name?.toLowerCase() ===
                                      "MasterData"?.toLowerCase() ||
                                    row?.format_details?.name?.toLowerCase() ===
                                      "WantingData"?.toLowerCase()
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              size="small"
                              onClick={() => {
                                if (isNotAllowedExtension(row?.csv_name)) {
                                  return;
                                } else if (
                                  row?.format_details?.name?.toLowerCase() !==
                                    "MasterData"?.toLowerCase() &&
                                  row?.format_details?.name?.toLowerCase() !==
                                    "WantingData"?.toLowerCase()
                                ) {
                                  handleRowClick(row?.id);
                                }
                              }}
                            >
                              View Report
                            </Button>
                          )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          // rowsPerPageOptions={[5, 10, 25, 30]}
          rowsPerPageOptions={undefined}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={dashboardPageNumber}
          onPageChange={handleChangePage}

          // onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>

      {/* Select Agencies Modal */}
      <Modal
        open={openSelectAgenciesModal}
        onClose={() => {
          setOpenSelectAgenciesModal(false);
          setSelectedAgencies([]);
        }}
        aria-labelledby="select-agencies-modal"
        aria-describedby="select-agencies-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 1,
          }}
        >
          <Typography id="select-agencies-modal" variant="h6" component="h2" gutterBottom>
            Select Agencies
          </Typography>
        <FormControl fullWidth margin="normal">
          <InputLabel id="agencies-multiselect-label">Select Agencies</InputLabel>
          <Select
            labelId="agencies-multiselect-label"
            multiple
            value={selectedAgencies}
            onChange={(e) => {
              const value = e.target.value;
              // Material-UI Select with multiple always returns an array
              setSelectedAgencies(value);
            }}
            renderValue={(selected) => {
              if (!selected || selected.length === 0) return "None";
              return agenciesList
                .filter((item) => selected.includes(String(item.agency_id || item.id)))
                .map((item) => item.name)
                .join(", ");
            }}
          >
            {agenciesList.map((agency) => {
              const agencyId = String(agency.agency_id || agency.id);
              const isChecked = selectedAgencies.includes(agencyId);
              return (
                <MenuItem key={agencyId} value={agencyId}>
                  <Checkbox
                    checked={isChecked}
                  />
                  <ListItemIcon />
                  <Typography variant="body2">{agency.name}</Typography>
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText>Select multiple agencies to assign</FormHelperText>
        </FormControl>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSaveSelectedAgencies}
            disabled={!selectedAgencies || selectedAgencies.length === 0}
          >
            Save
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setOpenSelectAgenciesModal(false);
              setSelectedAgencies([]);
            }}
          >
            Cancel
          </Button>
        </Box>
        </Box>
      </Modal>

      {/* Loader Backdrop */}
      <Backdrop open={downloadCSVLoading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Dashboard;
